import getConfig from 'next/config';

const { publicRuntimeConfig: features } = getConfig();

// Client side
const stdPLPFetcher = (...args) =>
  fetch(...args)
    .then((r) => {
      if (r.ok) {
        return r.json();
      }
      if (r.status === 404) {
        return { error: 404 };
      }
      throw new Error('An unexpected response has occurred');
    })
    .catch((e) => {
      throw new Error(e);
    });

export const PATH_PRODUCT_CHUNK = `${features.applicationPrefix}/api/product-chunks`;

export const getProductChunks = (
  {
    page = 1,
    chunk = 1,
    term = '',
    type = '',
    facetId = '',
    sortBy = '',
    listHead = '',
    lolcode = '',
    price = '',
    priceBands = '',
  },
  pageCorrelationId
) =>
  stdPLPFetcher(
    `${PATH_PRODUCT_CHUNK}?page=${page}&chunk=${chunk}&term=${encodeURIComponent(
      term
    )}&type=${type}&facetId=${facetId}&sortBy=${sortBy}&price=${price}&priceBands=${priceBands}&listHead=${listHead}&lolcode=${lolcode}`,
    {
      headers: {
        [features.pageCorrelationId]: pageCorrelationId,
      },
    }
  );
